import React from "react";
import { useField, useFormikContext } from "formik";
import { FormField, Label } from "semantic-ui-react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

export default function MyDateInput({ label, ...props }) {
  const { setFieldValue } = useFormikContext();
  const [field, meta] = useField(props);

  let dateFromFirestore = field.value;
  //check if date input is comming from firestore or from form input
  // since date from firestore does not come directly in timestamp object format, we have to convert using .toDate()
  if (field.value?.seconds) {
    dateFromFirestore = field.value.toDate();
  }
  return (
    <FormField error={meta.touched && !!meta.error}>
      <label>{label}</label>
      <DatePicker
        {...field}
        {...props}
        // selected={(field.value && new Date(field.value)) || null}
        selected={(field.value && new Date(dateFromFirestore)) || null}
        onChange={(value) => setFieldValue(field.name, value)}
        popperPlacement='top-end'
        popperModifiers={{
          preventOverflow: {
            enabled: true,
            escapeWithReference: false,
            boundariesElement: "viewport",
          },
        }}
      />
      {meta.touched && meta.error ? (
        <Label basic color='red'>
          {meta.error}
        </Label>
      ) : null}
    </FormField>
  );
}
